import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GA_ID = 'G-4D2HQM0KM1';

function gtag() {
  if (window.gtag) window.gtag(...arguments);
}

/**
 * Track SPA page views on every route change.
 * Also respects cookie consent — only fires if analytics consent given.
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Check cookie consent
    try {
      const consent = JSON.parse(localStorage.getItem('bib_cookie_consent') || '{}');
      if (consent.analytics === false) return;
    } catch {}

    gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location]);
}

/**
 * Custom event tracking for key conversion actions.
 * Usage: trackGA('blueprint_started', { step: 1 })
 */
export function trackGA(eventName, params = {}) {
  try {
    const consent = JSON.parse(localStorage.getItem('bib_cookie_consent') || '{}');
    if (consent.analytics === false) return;
  } catch {}

  gtag('event', eventName, {
    ...params,
    send_to: GA_ID,
  });
}

/**
 * Pre-built conversion events for key flows.
 */
export const GA_EVENTS = {
  // Blueprint funnel
  blueprintStarted: () => trackGA('blueprint_started', { event_category: 'blueprint' }),
  blueprintStepCompleted: (step) => trackGA('blueprint_step', { event_category: 'blueprint', step_number: step }),
  blueprintCompleted: () => trackGA('blueprint_completed', { event_category: 'blueprint' }),
  
  // Lead capture funnel
  resultsViewed: () => trackGA('results_viewed', { event_category: 'conversion' }),
  captureFormViewed: () => trackGA('capture_form_viewed', { event_category: 'conversion' }),
  leadCaptured: (tier) => trackGA('lead_captured', { event_category: 'conversion', lead_tier: tier }),
  
  // Content engagement
  neighbourhoodViewed: (slug) => trackGA('neighbourhood_viewed', { event_category: 'content', neighbourhood: slug }),
  guideViewed: (slug) => trackGA('guide_viewed', { event_category: 'content', guide: slug }),
  ctaClicked: (location) => trackGA('cta_clicked', { event_category: 'engagement', cta_location: location }),
  
  // Navigation
  navClicked: (item) => trackGA('nav_clicked', { event_category: 'navigation', nav_item: item }),
};
